export const SCENE_DRAWER_FORM_FIELD = {
  POSITION: 'position',
  NUMBER: 'number',
  LENGTH: 'duration',
  TITLE: 'title',
  DESCRIPTION: 'description',
  NOTES: 'notes',
};
